var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34904 0C5.73436 0 6.04672 0.31236 6.04672 0.697675V3.48837C6.04672 3.87369 5.73436 4.18605 5.34904 4.18605C4.96373 4.18605 4.65137 3.87369 4.65137 3.48837V0.697675C4.65137 0.31236 4.96373 0 5.34904 0Z",
    fill: "url(#paint0_linear_1616_3926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7904 0C13.1758 0 13.4881 0.31236 13.4881 0.697675V3.48837C13.4881 3.87369 13.1758 4.18605 12.7904 4.18605C12.4051 4.18605 12.0928 3.87369 12.0928 3.48837V0.697675C12.0928 0.31236 12.4051 0 12.7904 0Z",
    fill: "url(#paint1_linear_1616_3926)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.465332 7.29289C0.465332 6.90757 0.777692 6.59521 1.16301 6.59521H16.977C17.3623 6.59521 17.6746 6.90757 17.6746 7.29289C17.6746 7.6782 17.3623 7.99056 16.977 7.99056H1.16301C0.777692 7.99056 0.465332 7.6782 0.465332 7.29289Z",
    fill: "url(#paint2_linear_1616_3926)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31358 3.84674C1.71755 4.48862 1.39535 5.4557 1.39535 6.7441V14.6511C1.39535 15.9395 1.71755 16.9066 2.31358 17.5484C2.90091 18.181 3.85391 18.6046 5.34884 18.6046H12.7907C14.2856 18.6046 15.2386 18.181 15.826 17.5484C16.422 16.9066 16.7442 15.9395 16.7442 14.6511V6.7441C16.7442 5.4557 16.422 4.48862 15.826 3.84674C15.2386 3.21423 14.2856 2.79061 12.7907 2.79061H5.34884C3.85391 2.79061 2.90091 3.21423 2.31358 3.84674ZM1.29107 2.89728C2.21537 1.90188 3.58795 1.39526 5.34884 1.39526H12.7907C14.5516 1.39526 15.9242 1.90188 16.8485 2.89728C17.7641 3.88331 18.1395 5.2418 18.1395 6.7441V14.6511C18.1395 16.1534 17.7641 17.5119 16.8485 18.4979C15.9242 19.4933 14.5516 19.9999 12.7907 19.9999H5.34884C3.58795 19.9999 2.21537 19.4933 1.29107 18.4979C0.375473 17.5119 0 16.1534 0 14.6511V6.7441C0 5.2418 0.375473 3.88331 1.29107 2.89728Z",
    fill: "url(#paint3_linear_1616_3926)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5767 11.5814C11.5767 11.0676 11.9931 10.6511 12.5069 10.6511H12.5153C13.029 10.6511 13.4455 11.0676 13.4455 11.5814C13.4455 12.0951 13.029 12.5116 12.5153 12.5116H12.5069C11.9931 12.5116 11.5767 12.0951 11.5767 11.5814Z",
    fill: "url(#paint4_linear_1616_3926)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5767 14.3721C11.5767 13.8584 11.9931 13.4419 12.5069 13.4419H12.5153C13.029 13.4419 13.4455 13.8584 13.4455 14.3721C13.4455 14.8859 13.029 15.3024 12.5153 15.3024H12.5069C11.9931 15.3024 11.5767 14.8859 11.5767 14.3721Z",
    fill: "url(#paint5_linear_1616_3926)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13525 11.5814C8.13525 11.0676 8.55173 10.6511 9.06549 10.6511H9.07386C9.58761 10.6511 10.0041 11.0676 10.0041 11.5814C10.0041 12.0951 9.58761 12.5116 9.07386 12.5116H9.06549C8.55173 12.5116 8.13525 12.0951 8.13525 11.5814Z",
    fill: "url(#paint6_linear_1616_3926)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13525 14.3721C8.13525 13.8584 8.55173 13.4419 9.06549 13.4419H9.07386C9.58761 13.4419 10.0041 13.8584 10.0041 14.3721C10.0041 14.8859 9.58761 15.3024 9.07386 15.3024H9.06549C8.55173 15.3024 8.13525 14.8859 8.13525 14.3721Z",
    fill: "url(#paint7_linear_1616_3926)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69238 11.5814C4.69238 11.0676 5.10886 10.6511 5.62262 10.6511H5.63097C6.14472 10.6511 6.5612 11.0676 6.5612 11.5814C6.5612 12.0951 6.14472 12.5116 5.63097 12.5116H5.62262C5.10886 12.5116 4.69238 12.0951 4.69238 11.5814Z",
    fill: "url(#paint8_linear_1616_3926)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69238 14.3721C4.69238 13.8584 5.10886 13.4419 5.62262 13.4419H5.63097C6.14472 13.4419 6.5612 13.8584 6.5612 14.3721C6.5612 14.8859 6.14472 15.3024 5.63097 15.3024H5.62262C5.10886 15.3024 4.69238 14.8859 4.69238 14.3721Z",
    fill: "url(#paint9_linear_1616_3926)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1616_3926",
    x1: 4.80521,
    y1: 0.801682,
    x2: 6.54562,
    y2: 1.36137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1616_3926",
    x1: 12.2466,
    y1: 0.801682,
    x2: 13.987,
    y2: 1.36137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1616_3926",
    x1: 2.36277,
    y1: 6.86244,
    x2: 2.52889,
    y2: 8.83906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1616_3926",
    x1: 2,
    y1: 4.9583,
    x2: 15.2457,
    y2: 17.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1616_3926",
    x1: 11.7827,
    y1: 11.0074,
    x2: 13.1091,
    y2: 12.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1616_3926",
    x1: 11.7827,
    y1: 13.7982,
    x2: 13.1091,
    y2: 15.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1616_3926",
    x1: 8.34131,
    y1: 11.0074,
    x2: 9.6677,
    y2: 12.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1616_3926",
    x1: 8.34131,
    y1: 13.7982,
    x2: 9.6677,
    y2: 15.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1616_3926",
    x1: 4.89843,
    y1: 11.0074,
    x2: 6.22483,
    y2: 12.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1616_3926",
    x1: 4.89843,
    y1: 13.7982,
    x2: 6.22483,
    y2: 15.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A6BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.186ce3fe49ffaa68338843733064631d.svg";
export { ForwardRef as ReactComponent };